import { render, staticRenderFns } from "./ManageAvatarForm.vue?vue&type=template&id=58e99a8f&"
import script from "./ManageAvatarForm.vue?vue&type=script&lang=js&"
export * from "./ManageAvatarForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports